import React from "react";
import { getStatusTone } from "../lib/workflows";

/* StatusPill — single unified pill for any status value across the app.
   Pulls its color + display label from `/lib/workflows.js` so all rows,
   tables, and cards stay visually consistent.

   Props:
     value        backend status string (required)
     label        optional override for display text
     size         "sm" | "md" (default "sm")
     variant      "solid" | "soft" (default "solid"). `soft` paints a
                  tinted background with the tone color as text — quieter
                  in dense list rows.
     testId       data-testid (optional)
*/
export default function StatusPill({
  value,
  label,
  size = "sm",
  variant = "solid",
  testId,
}) {
  const tone = getStatusTone(value);
  const px = size === "md" ? 14 : 12;
  const py = size === "md" ? 6 : 5;
  const fs = size === "md" ? 12 : 11;
  const isSoft = variant === "soft";
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: `${py}px ${px}px`,
        borderRadius: 999,
        backgroundColor: isSoft ? tone.soft : tone.bg,
        color: isSoft ? tone.bg : tone.fg,
        fontSize: fs,
        fontWeight: 700,
        letterSpacing: "0.05em",
        textTransform: "uppercase",
        fontFamily: '"Nunito Sans", sans-serif',
        whiteSpace: "nowrap",
      }}
      data-testid={testId || `status-pill-${String(value || "unknown").replace(/\s+/g, "_")}`}
    >
      {label || tone.label}
    </span>
  );
}
